import { render, staticRenderFns } from "./IndexConfiguracionCamara.vue?vue&type=template&id=363c6509&scoped=true&"
import script from "./IndexConfiguracionCamara.vue?vue&type=script&lang=ts&"
export * from "./IndexConfiguracionCamara.vue?vue&type=script&lang=ts&"
import style0 from "./IndexConfiguracionCamara.vue?vue&type=style&index=0&id=363c6509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363c6509",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('363c6509', component.options)
    } else {
      api.reload('363c6509', component.options)
    }
    module.hot.accept("./IndexConfiguracionCamara.vue?vue&type=template&id=363c6509&scoped=true&", function () {
      api.rerender('363c6509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ClasificacionPatentes/IndexConfiguracionCamara.vue"
export default component.exports